import { WorkflowStageTemplate } from '../models/workflow-stage-template';
import { WorkflowStageTemplateProperty } from '../../../models';
import { Mapper } from '../../../mappers';

export class WorkflowStageTemplateMapper extends Mapper<
  WorkflowStageTemplate[],
  WorkflowStageTemplateProperty[]
> {
  from(source: WorkflowStageTemplate[]): WorkflowStageTemplateProperty[] {
    return source.map(
      (item) =>
        ({
          key: item.Key,
          name: item.Name,
          sequence: item.Sequence,
          workflowKey: item.WorkflowKey,
          isSequential: item.IsSequential,
        }) as WorkflowStageTemplateProperty,
    );
  }
}
